module.exports = __webpack_public_path__ + "static/media/jamsHoney.8242c932.webp";